<div class="elements-references">
    <div class="elements">
        <h3>{{'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.STEPS.ELEMENTS.TITLE' | translate }}</h3>
        <div class="elements-div">
            <mat-card *ngIf="!disabled" class="form-card">
                <mat-card-header>
                    <mat-card-title>
                        {{ 'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.STEPS.ELEMENTS.NEW_ITEM' | translate }}
                    </mat-card-title>
                    <div class="action-buttons">
                        <button mat-raised-button color="primary" (click)="add()"
                            [disabled]="formGroup.invalid || !formGroup.get('id').value"
                            [matTooltip]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.STEPS.ELEMENTS.ADD_ITEM' | translate">
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                </mat-card-header>
                <mat-card-content>
                    <form [formGroup]="formGroup">
                        <mat-form-field>
                            <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.ACTION_TYPE' | translate
                                }}</mat-label>
                            <mat-select [(value)]="selectedOption">
                                <mat-option *ngFor="let option of actionOptions" [value]="option">{{option.value |
                                    translate}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field class="w100">
                            <input type="text" matInput formControlName="search" [matAutocomplete]="auto"
                                [placeholder]="'SEARCH.INPUT.PLACEHOLDER' | translate">
                            <div matSuffix class="app-suffix-search-icon-wrapper">
                                <button mat-icon-button (click)="searchElements()">
                                    <mat-icon>search</mat-icon>
                                </button>
                            </div>
                            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
                                (optionSelected)="addBoud($event.option.value)">
                                <mat-option *ngFor="let boud of options" [value]="boud"
                                    [ngStyle]="isSelected(boud, 'search') ? { 'background-color': '#f0f8ff'} : {}" [matTooltip]="boud.content?.spanishContent?.title">
                                    {{boud.name}}
                                    <ng-container *ngIf="boud.content?.spanishContent?.title as title">
                                        {{' - ' + title.substring(0, 90) + (title.length > 90 ? '...' : '')}}
                                    </ng-container>
                                </mat-option>
                            </mat-autocomplete>
                            <mat-error *ngIf="formGroup.get('search').hasError('minlength')">
                                {{ 'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.STEPS.ELEMENTS.MIN_LENGTH' | translate }}
                            </mat-error>
                        </mat-form-field>

                        <div class="spinner-center" *ngIf="loading">
                            <mat-spinner></mat-spinner>
                        </div>
                        <div *ngIf="!loading && formGroup.get('name').value" class="formDiv">
                            <mat-form-field class="w100">
                                <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.ELEMENTS.ID' | translate
                                    }}</mat-label>
                                <input matInput formControlName="name">
                            </mat-form-field>

                            <mat-form-field class="w100" *ngIf="formGroup.get('title').value">
                                <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.ELEMENTS.TITLE' |
                                    translate
                                    }}</mat-label>
                                <textarea matInput cdkTextareaAutosize formControlName="title"></textarea>
                            </mat-form-field>

                            <smt-search-select [group]="formGroup" [controlName]="'type'" [useChips] = "false"
                                [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.TYPE'"></smt-search-select>

                            <smt-search-select *ngIf="formGroup.get('subtype').value" [group]="formGroup"
                                [controlName]="'subtype'" [useChips] = "false"
                                [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.SUBTYPE'"></smt-search-select>

                            <smt-search-select *ngIf="formGroup.get('primaryApprovingBody').value" [group]="formGroup"
                                [controlName]="'primaryApprovingBody'" [useChips] = "false"
                                [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.PRIMARY_APPROVING_BODY'"></smt-search-select>

                            <!--<smt-search-select *ngIf="formGroup.get('secondaryApprovingBody').value" [group]="formGroup"
                                [controlName]="'secondaryApprovingBody'" [useChips] = "false"
                                [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.SECONDARY_APPROVING_BODY'"></smt-search-select>

                            <smt-search-select *ngIf="formGroup.get('secondaryApprovingBodySub').value"
                                [group]="formGroup" [controlName]="'secondaryApprovingBodySub'" [useChips] = "false"
                                [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.SECONDARY_APPROVING_BODY_SUB'"></smt-search-select>-->

                            <mat-form-field class="w45">
                                <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.PROVISION_NUMBER' |
                                    translate
                                    }}</mat-label>
                                <input matInput formControlName="provisionNumber">
                            </mat-form-field>

                            <div class="w45">
                                <smt-search-select [group]="formGroup" [controlName]="'actionType'" [useChips] = "false"
                                    [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.ACTION_TYPE'"></smt-search-select>
                            </div>

                            <div class="w45">
                                <smt-date-input [group]="formGroup" [controlName]="'approvalDate'"
                                    [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.APPROVAL_DATE'"></smt-date-input>
                            </div>

                            <div class="w45">
                                <smt-date-input [group]="formGroup" [controlName]="'effectiveDate'"
                                    [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.EFFECTIVE_DATE'"></smt-date-input>
                            </div>
                        </div>
                    </form>
                </mat-card-content>
            </mat-card>
            <div [hidden]="!hasSomeElement()" [ngClass]="!disabled ? 'element-forms' : 'w100'">
                <boud-element-form #mentionedForm [group]="group" [disabled]="disabled"
                    [controlName]="'mentionedElements'" [elements]="boud?.elements?.mentionedElements"
                    [actionType]="elementActionTypes.UDEU_BOUD_MENTION_ACTION_TYPE"></boud-element-form>
                <boud-element-form #suspendedForm [group]="group" [disabled]="disabled"
                    [controlName]="'suspendedElements'" [elements]="boud?.elements?.suspendedElements"
                    [actionType]="elementActionTypes.UDEU_BOUD_SUSPENSION_ACTION_TYPE"></boud-element-form>
                <boud-element-form #modifiedForm [group]="group" [disabled]="disabled"
                    [controlName]="'modifiedElements'" [elements]="boud?.elements?.modifiedElements"
                    [actionType]="elementActionTypes.UDEU_BOUD_MODIFICATION_ACTION_TYPE"></boud-element-form>
                <boud-element-form #repealedForm [group]="group" [disabled]="disabled"
                    [controlName]="'repealedElements'" [elements]="boud?.elements?.repealedElements"
                    [actionType]="elementActionTypes.UDEU_BOUD_REPEAL_ACTION_TYPE"></boud-element-form>
                <boud-element-form #correctedForm [group]="group" [disabled]="disabled"
                    [controlName]="'correctedElements'" [elements]="boud?.elements?.correctedElements"
                    [actionType]="elementActionTypes.UDEU_BOUD_CORRECTION_ACTION_TYPE"></boud-element-form>
            </div>
            <mat-card *ngIf="!hasSomeElement()" class="center">
                <mat-card-content>
                    {{ 'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.STEPS.ELEMENTS.EMPTY_ITEM' | translate }}
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="references" *ngIf="hasSomeReference()">
        <h3>{{'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.STEPS.REFERENCES.TITLE' | translate }}</h3>
        <div class="w100">
            <boud-element-form #mentionerForm [group]="group" [disabled]="true" [controlName]="'mentionersElements'"
                [references]="boud?.references?.mentionersElements"
                [actionType]="elementActionTypes.UDEU_BOUD_MENTION_ACTION_TYPE"></boud-element-form>
            <boud-element-form #modifierForm [group]="group" [disabled]="true" [controlName]="'modifiersElements'"
                [references]="boud?.references?.modifiersElements"
                [actionType]="elementActionTypes.UDEU_BOUD_MODIFICATION_ACTION_TYPE"></boud-element-form>
            <boud-element-form #repealerForm [group]="group" [disabled]="true" [controlName]="'repealersElements'"
                [references]="boud?.references?.repealersElements"
                [actionType]="elementActionTypes.UDEU_BOUD_REPEAL_ACTION_TYPE"></boud-element-form>
            <boud-element-form #suspenderForm [group]="group" [disabled]="true" [controlName]="'suspendersElements'"
                [references]="boud?.references?.suspendersElements"
                [actionType]="elementActionTypes.UDEU_BOUD_SUSPENSION_ACTION_TYPE"></boud-element-form>
            <boud-element-form #correctorForm [group]="group" [disabled]="true" [controlName]="'correctorsElements'"
                [references]="boud?.references?.correctorsElements"
                [actionType]="elementActionTypes.UDEU_BOUD_CORRECTION_ACTION_TYPE"></boud-element-form>
        </div>
    </div>
</div>